import M from 'materialize-css' // Importa Materialize CSS

export default {

  async createStampToast (logo, msg, tipo) {
    M.toast({
      html: '<i class="material-icons left">' + logo + '</i> ' + msg,
      classes: tipo + ' darken-2 rounded-toast wide-toast', // Aggiungi la classe 'wide-toast'
      displayLength: 3000
    })
  }

}
